import { format } from 'winston';

const filterLogs = format((logObject, opts) => {
  if (opts.includes(logObject?.url?.path)) {
    return false;
  }

  return logObject;
});

export default filterLogs;
